import {SxProps, Theme} from "@mui/material";
import {useMemo} from "react";

export const useSliderStyle = (maxPcc: number, dragging: boolean) => {
  return useMemo<SxProps<Theme>>(() => {
    const clamped = Math.min(Math.max(maxPcc, 0.2), 1);
    const percent = ((clamped - 0.2) / (1 - 0.2)) * 100;

    return {
      color: "#f8f9fa",
      marginRight: "0",
      "& .MuiSlider-track": {
        background: "transparent",
        backgroundColor: "#f8f9fa",
      },
      "& .MuiSlider-rail": {
        background: `linear-gradient(to top, #ccc ${percent}%, rgba(200,200,200,0.5) ${percent}%)`,
      },
      "& .MuiSlider-thumb": {
        width: 24,
        height: 10,
        borderRadius: 4,
        backgroundColor: "#f8f9fa",
        "&:hover, &.Mui-focusVisible": {
          boxShadow: "0 0 0 6px rgba(240,240,240,0.16)",
        },
      },
      '&:hover .MuiSlider-markLabel': {
        opacity: 1,
      },
      '& .MuiSlider-markLabel': {
        left: 0,
        transform: 'translateX(-100%) translateY(50%)', // shift labels fully to the left
        textAlign: 'right',
        color: 'white',
        whiteSpace: 'nowrap', // prevents wrapping
        opacity: dragging ? 1 : 0,
        transition: "opacity 0.5s",
      },
      '& .MuiSlider-mark': {
        left: "10px", // half of thumb width
        backgroundColor: 'white',
        width: "13px",
      },
    };
  }, [maxPcc, dragging]);
};
